<template>
  <div>
    <el-form
      :model="formData"
      ref="ruleForm"
      status-icon
      :rules="rules"
      label-position="left"
      label-width="80px"
      size="default"
    >
      <div class="table-container">
        <el-row :gutter="20" justify="middle" align="center">
          <el-col :span="24">
            <div class="grid-content">客户信息表</div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="4"> <div class="grid-content">客户名称</div> </el-col>
          <el-col :span="4"
            ><div class="grid-content">
              <el-input
                v-model="formData.customerName"
                clearable="true"
              ></el-input></div
          ></el-col>
          <el-col :span="4"> <div class="grid-content">用户名称</div> </el-col>
          <el-col :span="4"
            ><div class="grid-content">
                <el-input v-model="userName" clearable="true"></el-input>
            </div>
          </el-col>
          <el-col :span="4"><div class="grid-content">业务</div></el-col>
          <el-col :span="4"
            ><div class="grid-content">
              <el-input
                v-model="formData.salesman"
                clearable="true"
              ></el-input></div
          ></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="4"><div class="grid-content">公司地址</div></el-col>
          <el-col :span="20"
            ><div class="grid-content">
              <el-input
                v-model="formData.companyAddress"
                clearable="true"
              ></el-input></div
          ></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="4"><div class="grid-content">分成模式</div></el-col>
          <el-col :span="20"
            ><div class="grid-content">
              <el-radio-group v-model="formData.commissionModel">
                <el-radio :label="'0'">按比例</el-radio>
                <el-radio :label="'1'">底价</el-radio>
                <el-radio :label="'2'">流量池</el-radio>
              </el-radio-group>
            </div></el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="4"
            ><div class="grid-content">使用设备及场景描述</div></el-col
          >
          <el-col :span="20"
            ><div class="grid-content">
              <el-input
                v-model="formData.useDevice"
                clearable="true"
              ></el-input></div
          ></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="4"
            ><div class="grid-content-image">使用设备图片</div></el-col
          >
          <el-col :span="20"
            ><div class="grid-content-image">
              <el-image
                style="width: 70vh; height: 200px"
                :src="formData.businessLicensePicture"
                :preview-src-list="srcList"
              >
              </el-image></div
          ></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="4"><div class="grid-content">联系人</div></el-col>
          <el-col :span="8"
            ><div class="grid-content">
              <el-input
                v-model="formData.linkman"
                clearable="true"
              ></el-input></div
          ></el-col>
          <el-col :span="4"><div class="grid-content">联系人电话</div></el-col>
          <el-col :span="8"
            ><div class="grid-content">
              <el-input
                v-model="formData.linkmanPhone"
                clearable="true"
              ></el-input></div
          ></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="4"
            ><div class="grid-content-image">公司营业执照图片</div></el-col
          >
          <el-col :span="20"
            ><div class="grid-content-image">
              <el-image
                style="width: 70vh; height: 200px"
                :src="formData.useDevicePicture"
                :preview-src-list="srcList"
              >
              </el-image></div
          ></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="4"><div class="grid-content">备注</div></el-col>
          <el-col :span="20"
            ><div class="grid-content">
              <el-input
                v-model="formData.remark"
                clearable="true"
              ></el-input></div
          ></el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>
<script>
import { historicActivityPerson } from "@/api/api.js"; //流程实例分页查询
import { processFromData } from "@/api/api.js"; //附加单据
import Schema from 'async-validator';
export default {
  data() {
    return {
      formData: {},
      userName: "",
      srcList: [
        "https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg",
        "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
      ],
      //   queryParams: {},
      //   tableData: [],
      //   page: 1,
      //   pageSize: 20,
      //   total: 0,
      rules: {
        name: [
          { required: true, message: "请输入代理商用户名", trigger: "blur" }
        ],
      },
    };
  },
  props: {
    childId: {
      type: String,
    },
    childProcessId: {
      type: String,
    },
    fromType: {
      type: Number,
    },
  },
  methods: {
    // 获取列表的数据
    initData() {
      let params = {
        processInstanceId: this.childProcessId,
        taskId: this.childId,
      };
      //   processInstanceImage(params).then(res=>{
      //     this.str = res.data
      //   });
      processFromData(params).then((res) => {
        if (res.data.code == 200) {
          if (this.fromType == 1) {
            this.formData = res.data.data.AddCustomerV2;
          }
        }
      });
    },
    // 历史
    // editRow(id) {
    //   this.$router.push({ path: `/procedure/lcslHistory?id=${id}` });
    // },
    // 搜索
    // search() {
    //   (this.page = 1), this.initData();
    // },
    // 重置
    // resetForm() {
    //   for (var i in this.queryParams) {
    //     this.queryParams[i] = null;
    //   }
    //   this.initData();
    // },
    // handleSizeChange(pageSize) {
    //   this.pageSize = pageSize;
    //   this.initData();
    // },
    // handleCurrentChange(page) {
    //   this.page = page;
    //   this.initData();
    // },
  },

  mounted() {
    this.initData();
  },
  created() {},
};
</script>
<style scoped lang="less">
.el-row {
  //   margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 0px;
  //   min-height: 36px;
  border: 1px solid #4d4d4d;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 46px;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;
}

.grid-content-image {
  border-radius: 4px;
  min-height: 300px;
  padding: 10px;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

div.table-container {
  margin-top: 50px;
  margin-left: 220px;
  max-width: 1200px;
  padding: 20px;
  border-radius: 5px;
  border: 1px solid black;
  table.table-layout {
    table-layout: fixed;
    border-collapse: collapse;
    width: 1080px;

    td.table-cell {
      display: table-cell;
      height: 36px;
      border: 1px solid black;
      text-align: center;
    }
  }
}
.table-checkbox,
.table-radio {
  display: table-cell;
  border: 1px solid black;
  text-align: left;
}

.add-button {
  margin-top: -340px;
  margin-right: -10px;
  float: right;
  position: relative;
}
.save {
  margin-top: 50px;
  margin-left: 750px;
  position: relative;
}
.text-input {
  width: 100%;
  height: 100%;
  padding: 5px;
  border: 1px #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  text-align: center;
}
.radio-input {
  vertical-align: middle;
  margin-top: -2px;
  margin-bottom: 1px;
}
.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 138px;
  height: 138px;
}
.avatar-uploader:hover {
  border-color: #409eff;
}
.svg-avatar-uploader-icon {
  font-size: 28px;
  width: 60px;
  height: 60px;
  line-height: 18px;
  text-align: center;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 138px;
  height: 138px;
  // line-height: 88px;
  text-align: center;
}
.avatar {
  width: 138px;
  height: 138px;
  display: block;
}
</style>


